import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckboxComponent } from './IFE/components/checkbox/checkbox.component';
import { NavigationComponent } from './IFE/components/navigation/navigation.component';
import { TitleComponent } from './IFE/components/title/title.component';
import { ProgressBarComponent } from './IFE/components/progress-bar/progress-bar.component';
import { NotificationComponent } from './IFE/components/notification/notification.component';
import { LangSwitcherComponent } from './components/lang-switcher/lang-switcher.component';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipComponent } from './IFE/components/tooltip/tooltip.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProgressBarBulletsComponent } from './IFE/components/progress-bar/components/progress-bar-bullets/progress-bar-bullets.component';
import { ProgressBarImagesComponent } from './IFE/components/progress-bar/components/progress-bar-images/progress-bar-images.component';
import { ProgressBarLineComponent } from './IFE/components/progress-bar/components/progress-bar-line/progress-bar-line.component';

import { ProgressBarTextComponent } from './IFE/components/progress-bar/components/progress-bar-text/progress-bar-text.component';
import { SelectComponent } from './IFE/components/select/select.component';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { ImagePickerComponent } from './IFE/components/file-picker/image-picker.component';
import { ErrorMessageComponent } from './IFE/components/error-message/error-message.component';
import { HomeLinkDirective } from './directives/home-link.directive';

@NgModule({
  declarations: [
    CheckboxComponent,
    NavigationComponent,
    TitleComponent,
    ProgressBarComponent,
    NotificationComponent,
    LangSwitcherComponent,
    TooltipComponent,
    ProgressBarBulletsComponent,
    ProgressBarImagesComponent,
    ProgressBarTextComponent,
    SelectComponent,
    ImagePickerComponent,
    ErrorMessageComponent,
    ProgressBarLineComponent,
    HomeLinkDirective,
  ],
  imports: [CommonModule, TranslateModule, FormsModule, ReactiveFormsModule, NgbDropdownModule],
  exports: [
    CheckboxComponent,
    NavigationComponent,
    TitleComponent,
    ProgressBarComponent,
    NotificationComponent,
    LangSwitcherComponent,
    TooltipComponent,
    SelectComponent,
    ImagePickerComponent,
    ErrorMessageComponent,
    HomeLinkDirective,
  ],
})
export class SharedModule {}
